import React from 'react';
import { FooterMenu, IFooterMenuProps } from './FooterMenu';
import * as classes from './Footer.module.scss';
import { FooterSocialMedia, IFooterSocialMediaProps } from './FooterSocialMedia';
import logoUrl from '../../images/axes4_square_white.svg';
import { PageWidth } from '../layout/PageWidth';
import { ILegalLinksProps, LegalLinks } from './LegalLinks';

export interface IFooterProps {
    menus: IFooterMenuProps[];
    socialMediaMenu: IFooterSocialMediaProps;
    legalLinks: ILegalLinksProps;
}

export const Footer: React.FunctionComponent<IFooterProps> = (props) => {
    return (
        <footer className={classes.footer}>
            <div className={classes.upper}>
                <PageWidth className={classes.upperContainer}>
                    <div className={classes.logoWrapper}>
                        <img src={logoUrl} alt="" className={classes.logo}/>
                        <FooterSocialMedia {...props.socialMediaMenu} />
                    </div>
                    <div className={classes.menuWrapper}>
                        {props.menus.map((menuProps, i) => (
                            <FooterMenu key={i} {...menuProps} />
                        ))}
                    </div>
                </PageWidth>
            </div>
            <div className={classes.lower}>
                <PageWidth className={classes.lowerContainer}>
                    <LegalLinks {...props.legalLinks} />
                </PageWidth>
            </div>
        </footer>
    );
};
